function SectionHeading({ eyebrow, title, children, compact = false, className = '' }) {
  return (
    <div className={`${compact ? 'max-w-[850px]' : 'grid md:grid-cols-[1.1fr_0.55fr] gap-8 items-end'} ${className}`}>
      <div>
        <p className="text-sm font-black uppercase tracking-wider text-signal-dark mb-3">{eyebrow}</p>
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-extrabold leading-tight text-ink">{title}</h2>
      </div>
      {children && <div className="text-ink-soft leading-relaxed">{children}</div>}
    </div>
  );
}

export default SectionHeading;
